/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MoneyCurrencyRubleIcon20Light = forwardRef('MoneyCurrencyRubleIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 3a1 1 0 0 0-1 1v7H4.5a.5.5 0 0 0 0 1H6v2H4.5a.5.5 0 0 0 0 1H6v2.5a.5.5 0 0 0 1 0V15h4.5a.5.5 0 0 0 0-1H7v-2h4.5a4.5 4.5 0 1 0 0-9H7Zm4.5 8H7V4h4.5a3.5 3.5 0 1 1 0 7Z" })));
});
